export default "__VITE_ASSET__1bb52a40__"